export default "__VITE_ASSET__ejyDU16E__"